import type { UiText, UiTextTypeEnum } from "@ory/kratos-client";
import type React from "react";
import { Alert } from "~/components/Alert";

interface MessagesProps {
	messages?: Array<UiText>;
	hideTypes: Array<UiTextTypeEnum>;
}

export const Messages: React.FC<MessagesProps> = ({ messages, hideTypes }) => {
	if (!messages) {
		// No messages? Do nothing.
		return null;
	}
	return (
		<>
			{messages
				.filter((m) => m.type !== "success")
				.filter((m) => !hideTypes.some((t) => t === m.type))
				.map((message) => (
					<Alert key={message.id} type={message.type}>
						{message.text}
					</Alert>
				))}
		</>
	);
};
